import axios from "axios";

import config from "./../config/env";

export const getAllProjects = () => axios.get(`${config.API}/projects`);
